export class BusinessBookingRequestPostConfiguration {
    public startingDateUtc: string | null = null;
    public endingDateUtc: string | null = null;
    public totalAvailableUnits: number | null = null;
    public alreadyReservedUnits: number | null = null;
    public location: string | null = null;
    public buyable: boolean = false;
    public bookable: boolean = false;
    public buyableOrBookableInOurConsumers: boolean = false;
    public buyableOrBookableThroughExternalLink: boolean = false;
    public buyableOrBookableExternalLink: string | null = null;
    public buyableOrBookableUsingLocalDelivery: boolean = false;
    public buyableOrBookableUsingLocalDeliveryName: string | null = null;
    public buyableOrBookableUsingLocalDeliveryImageBase64: string | null = null;
    public buyableOrBookableThroughWhatsApp: boolean = false;
    public buyableOrBookableWhatsAppPhoneNumber: string | null = null;
    public price: number | null = null;
    public buyableOrBookableUntilDateUtc: string | null = null;
    public showingUpInGeneralFeed: boolean = true;

    constructor(json?: any) {
        if (!json) {
            return;
        }
        Object.assign(this, json);
    }
}

export enum PostType {
    PlainPost,
    Update,
    FlashOffer,
    Event
}

export enum PostGenerationType {
    Manual,
    AutomaticallyWhenProductWasPublished,
    AutomaticallyWhenServiceWasPublished
}
